import { Directive, HostListener, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { OverlaysService } from './overlays.service';

@Directive({
    selector: '[overlaysTarget]'
})
export class OverlaysTargetDirective implements OnInit, OnDestroy {

    constructor(private overlaysService: OverlaysService, private viewContainerRef: ViewContainerRef) {}

    ngOnInit() {
        this.overlaysService.overlaysHostRef = this.viewContainerRef;
    }

    @HostListener('document:keyup.escape')
    onEscape() {
        const overlayRef = this.overlaysService.getTopmostOverlay();
        if (overlayRef) {
            overlayRef.dismiss('escape');
        }
    }

    ngOnDestroy() {
        this.overlaysService.overlaysHostRef = null;
    }
}
